import ListCategoryPage from './ListCategoryPage.jsx';

export {
  ListCategoryPage
}


// WEBPACK FOOTER //
// ./pages/list-category/index.js